<template>
  <el-table-column
    prop="to"
    sortable="custom"
    label="Érvényesség vége"
    show-overflow-tooltip
    min-width="160"
  >
    <template slot-scope="scope">
      {{ scope.row.to | date }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'to',
  };
</script>
